// Centralized Application Versioning for SIMRS2
export const APP_VERSION = {
  version: '2.5.1',
  buildNumber: '20261027.01',
  releaseDate: '27 Oktober 2026',
  name: 'SIMRS2 Hospital & Finance Information System',
  framework: 'React 19 & Python Flask REST API',
  environment: 'Production',
  changelog: [
    {
      version: 'v2.5.1',
      date: '27 Oktober 2026',
      changes: [
        'Bridging E-Klaim v5.10.x: Dukungan penuh Dual-Engine Grouping iDRG Stage 1 & 2 dan INA-CBG Stage 2.',
        'Implementasi modul formula matematika Top-Up Payment sesuai Permenkes No. 3 Tahun 2023 (Kasus Sub-Akut, Kronis, iDRG Cost Weight, dan Hemodialisis Single-Use vs Re-Use).',
        'Validator Restriksi Kelas Rumah Sakit & Jenis Rawat untuk mencegah klaim tertolak (Odontektomi YY-16, PEG YY-15, Implant Hip/Knee RR-04, Coiling YY-13, Trombektomi YY-14, Brakiterapi YY-17, EVAR/TEVAR RR-05).',
        'Penyempurnaan UI Special CMG / Special Procedure (Phacoemulsification YY10 pada Operasi Katarak H-2-36-0): Default tidak ada (Rp 0), kalkulasi otomatis penambahan tarif saat dipilih (+Rp 3.465.000), dan fitur reset ke Rp 0 dengan pengiriman delimiter "#".',
        'Pendeteksian Kode Indonesian Modification (IM): Penandaan visual badge merah "IM tidak berlaku" pada daftar Diagnosa dan Prosedur INACBG yang memiliki field im = 1 pada tabel _idrg.',
        'Penyempurnaan error handling Web Service E-Klaim (E2014, E2016, E2063) dan proteksi status Ungroupable MDC 36.',
        'Unit test komprehensif untuk verifikasi formula numerik Top-Up Payment (10/10 tests passed).'
      ]
    },
    {
      version: 'v2.5.0',
      date: '12 September 2026',
      changes: [
        'Modul baru Aturan Penjualan Obat per Klasifikasi (/AturanJual).',
        'Fitur sinkronisasi otomatis harga obat (isiobatbaru) ke tabel stdjualkhusus.',
        'Kalkulasi otomatis harga jadi, HNA/HDA Normal & Paket, serta batas selisih laba.',
        'Laporan Laba Minus, Daftar Obat Titip, Obat Khusus, dan Setting Jual Ditutup (PDF).',
        'Fitur Pagination dinamis dan filter cepat untuk tampilan tabel tarif.',
        'Implementasi Versioning Aplikasi dan informasi rilis di halaman Home.'
      ]
    },
    {
      version: 'v2.4.2',
      date: '11 September 2026',
      changes: [
        'Modul Laporan Apotek: Tab Penjualan Obat per Klasifikasi.',
        'Export CSV & Cetak PDF format tabel penjualan per klasifikasi tanpa membuka tab baru.',
        'Progress bar visual saat proses penarikan data transaksi apotek.',
        'Integrasi Resume Medis Rawat Jalan (id_form 11) dari endpoint EHR Linimasa ke modul DataClaimPasien.'
      ]
    },
    {
      version: 'v2.4.0',
      date: '10 September 2026',
      changes: [
        'Integrasi Linimasa EMR / EHR Medical Info ke modul Data Claim Pasien.',
        'Pemrosesan data CPPT, Ringkasan Masuk/Keluar, dan Asesmen Awal Ranap.',
        'Penyempurnaan layout tabel rincian tagihan pasien.'
      ]
    }
  ]
};

export default APP_VERSION;
